export const CLICKED_BUTTON_EVENT = 'Clicked Button';
